import {getClickedMouseButton} from '../Utility/EventStateUtility';
import {getYTObject, setVideoRatioFromSlider} from './YoutubeUtility';

export class HeaderSliderController {

  readonly slickSliderSelector = '.js-headerSlider';
  readonly slideItemSelector = '.js-slideItem';
  readonly slideLinkSelector = '.js-slideLink';
  readonly youtubeSlideSelector = '.js-headerSlider-youtube';
  readonly defaultSlideTime = 3000;
  readonly youtubeClass = 'js-slideItem-youtube';
  protected $slickSlider: any = $(this.slickSliderSelector);
  protected youtubePlayers: { [key: string]: YT.Player } = {};
  protected slidesCount = 0;

  constructor() {
    if (document.querySelector(this.slickSliderSelector)) {
      this.init();
    }
  }

  protected init() {
    let isHotReloaded = this.$slickSlider[0].slick !== undefined;
    if ($(this.youtubeSlideSelector).length) {
      getYTObject();
      setVideoRatioFromSlider(this.$slickSlider);
    }

    this.$slickSlider.on('init', (event, slick) => {
      if (slick.$slides) {
        this.slidesCount = slick.$slides.length;
      }
      if (slick.$slider) {
        this.initializeAllVideos(slick.$slider);
      }

      this.$slickSlider.find('a.more').on('click', (linkEvent) => {
        linkEvent.preventDefault();
      });

      // add watcher for clicks on slide (avoiding clicks to slide slider)
      this.$slickSlider.find(this.slideItemSelector).on('mousedown', (event2) => {
        const $slide = $(event2.target).closest(this.slideItemSelector);

        switch (getClickedMouseButton(event2)) {
          case 'left':
            this.addMouseUpWatcher(event2, $slide);
            break;
          case 'middle':
            event2.preventDefault();
            this.decideWhatToDo($slide, true);
            break;
          default:
            event2.preventDefault();
            break;
        }
      });
    });

    this.$slickSlider.on('afterChange', (event, slick, currentSlide: number) => {
      this.stopAllYoutubeVideos();
      const $slide = $(slick.$slider).find('div[data-slick-index="' + currentSlide + '"]');
      const slideTime = parseFloat($slide.data('duration') || '1');
      this.$slickSlider.slick('setOption', 'autoplaySpeed', this.calculateSlideTime(slideTime));
      if ($slide.hasClass(this.youtubeClass)) {
        if (!this.youtubePlayers[currentSlide]) {
          this.setupNewPlayer($slide, currentSlide);
        } else {
          this.autoplayVideo($slide);
        }
      }
    });

    let slideTimeOfFirstSlide = parseFloat(this.$slickSlider.find('*[data-duration]').data('duration') || '1');

    if (!isHotReloaded) {
      this.$slickSlider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        infinite: true,
        autoplay: true,
        lazyLoad: 'ondemand',
        pauseOnFocus: false,
        pauseOnHover: false,
        autoplaySpeed: this.calculateSlideTime(slideTimeOfFirstSlide),
        speed: 300,
        dots: true,
      });
    }
  }

  private setupNewPlayer($slide, currentSlide: number) {
    getYTObject().then((YT) => {
      const $frame = $slide.find(this.youtubeSlideSelector);
      let config = JSON.parse($frame.data('config'));
      const elementID = 'youtube' + config.videoId + currentSlide;
      $frame.attr('id', elementID);
      this.youtubePlayers[currentSlide] = new YT.Player(elementID, {
        height: '400',
        width: '1170',
        videoId: config.videoId,
        playerVars: {
          showinfo: 0,
          rel: 0,
          loop: config.isVideoLooping ? 1 : 0,
          modestbranding: 1,
          disablekb: 1,
          playsinline: 1,
          controls: 0,
          autoplay: 0,
          start: config.start,
          end: config.end,
          mute: 1,
          fs: 0,
        },
        events: {
          'onReady': () => {
            this.youtubePlayers[currentSlide].mute();
            // start video instant if this is initial slide
            if (this.$slickSlider.slick('slickCurrentSlide') === currentSlide && $slide.hasClass(this.youtubeClass)) {
              this.autoplayVideo($slide);
            }
          },
          'onStateChange': (state) => {
            if (state.data === 0) {
              this.youtubePlayers[currentSlide].seekTo(config.start, true);
              this.youtubePlayers[currentSlide].playVideo();
            }
          },
        },
      });
    });
  }

  private addMouseUpWatcher(event, $slide: JQuery) {
    $slide.one('mouseup', (event2) => {
      if (event.screenX && event2.screenX && event.screenY && event2.screenY &&
          (Math.abs(event.screenX - event2.screenX) < 20) &&
          (Math.abs(event.screenY - event2.screenY) < 20)) {
        this.decideWhatToDo($slide, event.ctrlKey);
      } else {
        event.preventDefault();
      }
    });
  }

  private decideWhatToDo($slide: JQuery, openInNewWindow: boolean) {
    const $link = $slide.find(this.slideLinkSelector);
    let linkHref = $link.attr('href');
    if (linkHref && !/^https?:\/\//i.test(linkHref)) {
      linkHref = '/' + linkHref;
    }
    const linkTarget = $link.attr('target');
    if (typeof linkHref === 'string') {
      if (openInNewWindow || linkTarget === '_blank') {
        window.open(linkHref, '_blank');
      } else {
        window.location.href = linkHref;
      }
    }
  }

  private calculateSlideTime(time?: number): number {
    return time ? time * 1000 : this.defaultSlideTime;
  }

  private autoplayVideo($slide: JQuery) {
    const config = JSON.parse($slide.find(this.youtubeSlideSelector).data('config') || '');
    const player = this.youtubePlayers[parseInt($slide.data('slickIndex') || '0', 10)];
    this.startVideo(player, config.start, $slide);
  }

  private startVideo(player, startTime: number, $slide: JQuery) {
    if (player && typeof player.playVideo === 'function') {
      player.seekTo(startTime, true).playVideo();
    } else {
      // console.log('player not ready yet. TODO');
    }
  }

  private stopAllYoutubeVideos() {
    for (let playerId in this.youtubePlayers) {
      if (this.youtubePlayers[playerId] && typeof this.youtubePlayers[playerId].pauseVideo === 'function') {
        this.youtubePlayers[playerId].pauseVideo();
      }
    }
  }

  private initializeAllVideos($slider: JQuery) {
    $slider.find('.' + this.youtubeClass).each((index, slide) => {
      const $slide = $(slide);
      const slideIndex = $slide.attr('data-slick-index');
      if (slideIndex) {
        this.setupNewPlayer($slide, parseInt(slideIndex, 10));
      }
    });
  }
}
